import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import Form from "./Form";
import { isLogin, sendEmbedToken } from "../../constant/helper";
import { useHistory } from "react-router-dom";

const isAuthenticated = isLogin();
const Login = () => {
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated && history) {
      const searchParams = new URLSearchParams(window.location.search);
      const _continue = decodeURI(searchParams.get("continue") || "/home");
      history.replace(_continue);
      sendEmbedToken(searchParams);
    }
  }, [history]);

  return (
    <PageContainer header={false} classNames="container wrap-login">
      <div className="login-body">
        <Form
          loading={loading}
          setLoading={setLoading}
          agree={agree}
          setAgree={setAgree}
        />
      </div>
    </PageContainer>
  );
};

export default Login;
